import { render } from "./TvmFlowEndGeneralComponents.vue?vue&type=template&id=6d7d3412"
import script from "./TvmFlowEndGeneralComponents.vue?vue&type=script&lang=js"
export * from "./TvmFlowEndGeneralComponents.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__